import { httpsCallable } from "firebase/functions";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getFirebaseFunctions } from "../../firebase.ts";
import type { UserDetailDtoAtUser, UserDetailInputAtUser } from "components/userModel";

interface Response {
  success: boolean;
  message: string;
}

export const updateUserDetail = async (
  userId: string,
  input: UserDetailInputAtUser,
  uploadFiles: File[],
) => {
  const functions = getFirebaseFunctions();
  const storage = getStorage();

  const updateUserDetail = httpsCallable<UserDetailDtoAtUser, Response>(
    functions,
    "updateUserDetail",
  );

  const dirPrefix = `users/${userId}/detail/${Date.now()}`;

  const uploadedImages = await Promise.all(
    uploadFiles.map(async (file, index) => {
      const filePath = `${dirPrefix}/${index}-${file.name}`;
      const storageRef = ref(storage, filePath);

      // ファイルをアップロード
      await uploadBytes(storageRef, file);

      return {
        fileName: file.name,
        filePath,
        createdAt: new Date(),
      };
    }),
  );

  const res = await updateUserDetail({
    ...input,
    images: uploadedImages,
  });
  return res.data;
};
